module.exports = __webpack_public_path__ + "media/images/emoticons/ticket-a1ef92041223d9095783da8728d6f05f.gif";